"use client";
import { anatomy } from "@zag-js/date-picker";
//#region src/components/date-picker/date-picker.anatomy.ts
var datePickerAnatomy = anatomy.extendWith("view", "valueText");
//#endregion
export { datePickerAnatomy };
